const NOTIFICATION_ACTIONS = {
  // notification
  GET_ALL_NOTIFICATION_REQUEST: "GET_ALL_NOTIFICATION_REQUEST",
  GET_ALL_NOTIFICATION_SUCCESS: "GET_ALL_NOTIFICATION_SUCCESS",
  GET_ALL_NOTIFICATION_FAIL: "GET_ALL_NOTIFICATION_FAIL",
  GET_NOTIFICATION_NUMBER_SUCCESS: "GET_NOTIFICATION_NUMBER_SUCCESS",
  GET_MORE_NOTIFICATION_REQUEST: "GET_MORE_NOTIFICATION_REQUEST",
  GET_MORE_NOTIFICATION_SUCCESS: "GET_MORE_NOTIFICATION_SUCCESS",
  GET_MORE_NOTIFICATION_FAIL: "GET_MORE_NOTIFICATION_FAIL",
  GET_POLLING_NOTIFICATION_SUCCESS: "GET_POLLING_NOTIFICATION_SUCCESS",
  MARK_AS_READ: "MARK_AS_READ",
};
export default NOTIFICATION_ACTIONS;
